import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { locale, loadMessages as dxLoadMessages } from 'devextreme/localization';
import enTranslation from "./localization/en.json"
import nlTranslation from "./localization/nl.json"
import enMessages from "devextreme/localization/messages/en.json";
import nlMessages from "devextreme/localization/messages/nl.json";

const resources = {
  en: { translation: enTranslation },
  nl: { translation: nlTranslation }
}

const languageDetector = new LanguageDetector(null, {
  order: ['localStorage', 'navigator', 'htmlTag'],
  caches: ['localStorage'],
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'nl',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    debug: true,
  });

i18n.on('languageChanged', (lng) => {
  locale(lng);
});

dxLoadMessages({
  en: enMessages,
  nl: nlMessages
});
locale(i18n.language);

export default i18n;
